import { IconGift } from "@tabler/icons-react";

export function RewardReadyBadge({ label = "Можно забрать награду" }) {
  return <span className="reward-ready-badge" role="img" aria-label={label} title={label}>
    <IconGift aria-hidden="true" />
  </span>;
}
